/* Toont in de productgalerij alleen de foto's van de gekozen uitvoering.

   Tot 5 september 2026 gebeurde dat door de gekozen optiewaarde als woord in
   de alt-tekst van elke foto te zoeken. Dat werkt alleen in het Nederlands.
   In het Portugees heet de optie "Liso" terwijl de alt-tekst "Lisa" zegt, in
   het Duits staat "gedrehtes" naast optie "gedreht", en dan matcht er niets:
   de galerij filterde niet en bleef op foto 1 staan terwijl de kiezer een
   andere uitvoering aanwees. Een klant meldde dat voor de armband.

   Nu draagt elke foto een data-uitvoering met een Nederlandse sleutel uit zijn
   bestandsnaam, en zet kopero-product-gallery een kaart in de pagina die de
   vertaalde optiewaarde naar diezelfde sleutel vertaalt. Een foto zonder
   sleutel hoort bij alle uitvoeringen en blijft altijd staan. */
(function () {
  function normaliseer(waarde) {
    return (waarde || '')
      .toLocaleLowerCase('nl-NL')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function canoniek(sleutel) {
    try {
      var el = document.querySelector('[data-kopero-uitvoeringen]');
      if (!el) return sleutel;
      return JSON.parse(el.textContent || '{}')[sleutel] || sleutel;
    } catch (error) {
      return sleutel;
    }
  }

  function currentSelectedValue(root) {
    var vs = root.querySelector('variant-selects');
    if (!vs) return null;
    var gekozen = [...vs.querySelectorAll('fieldset, .product-form__input--dropdown')]
      .map(function (groep) {
        var veld = groep.querySelector('input:checked, select');
        return veld ? veld.value : null;
      })
      .filter(Boolean);
    if (gekozen.length) return normaliseer(gekozen.join('-'));

    var checked = vs.querySelector('input[type="radio"]:checked');
    if (checked) return normaliseer(checked.value);
    var select = vs.querySelector('select');
    return select ? normaliseer(select.value) : null;
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-kopero-gallery]');
    if (!gallery || gallery.dataset.koperoGalleryInit) return;
    gallery.dataset.koperoGalleryInit = 'true';

    var strip = gallery.querySelector('[data-duimen]');
    var platen = Array.prototype.slice.call(gallery.querySelectorAll('.kopero-gallery__plaat'));
    var duimen = Array.prototype.slice.call(gallery.querySelectorAll('.kopero-gallery__duim'));
    var pijlen = Array.prototype.slice.call(gallery.querySelectorAll('[data-plaat-schuif]'));
    // 4 oktober 2026: op een telefoon (< 750 px) staan de foto's naast elkaar in een rij die je zijwaarts veegt, met een
    // stukje van de volgende erbij. 'aan' volgt dan de foto die vooraan staat; de puntjes eronder tonen waar je bent.
    var hoofd = gallery.querySelector('.kopero-gallery__main');
    var klein = window.matchMedia('(max-width: 749px)');
    var punten = null;

    function laadPlaat(el) {
      var img=el && el.querySelector('img[data-kopero-gallery-src]');
      if(!img)return;
      var src=img.getAttribute('data-kopero-gallery-src');
      var srcset=img.getAttribute('data-kopero-gallery-srcset');
      // Install srcset first, so there is only one correctly sized request.
      if(srcset)img.setAttribute('srcset',srcset);
      img.setAttribute('src',src);
      img.removeAttribute('data-kopero-gallery-src');
      img.removeAttribute('data-kopero-gallery-srcset');
    }
    var fotoKijker=window.IntersectionObserver && hoofd ? new IntersectionObserver(function(entries){
      entries.forEach(function(entry){if(entry.isIntersecting && zichtbaar(entry.target)){laadPlaat(entry.target);fotoKijker.unobserve(entry.target);}});
    },{root:hoofd,rootMargin:'0px 80px',threshold:0.01}) : null;
    if(fotoKijker)platen.forEach(function(el){fotoKijker.observe(el);});


    function puntjes() {
      if (!hoofd) return;
      if (!klein.matches) { if (punten) punten.hidden = true; return; }
      var p = open(platen);
      if (!punten) {
        punten = document.createElement('div');
        punten.className = 'kopero-gallery__punten';
        punten.setAttribute('aria-hidden', 'true');
        hoofd.insertAdjacentElement('afterend', punten);
      }
      punten.hidden = p.length < 2;

      var i = huidig();
      punten.innerHTML = p.map(function (_, k) { return '<span' + (k === i ? ' class="aan"' : '') + '></span>'; }).join('');
    }

    // De pijlen zitten in de rij die zijwaarts scrolt en zouden dus meescrollen; op een telefoon staan ze daarom
    // boven de rij in de galerij zelf (zie de CSS), op een groter scherm weer op hun oude plek.
    function plaatsPijlen() {
      if (!hoofd) return;
      var doel = klein.matches ? gallery : hoofd;
      pijlen.forEach(function (k) { if (k.parentNode !== doel) doel.appendChild(k); });
    }

    function naarPlaat(el, zacht) {
      if (!hoofd || !klein.matches || !el) return;
      hoofd.scrollTo({ left: el.offsetLeft, behavior: zacht ? 'smooth' : 'auto' });
    }

    function zichtbaar(el) {
      return !el.classList.contains('uit');
    }

    function open(list) {
      return list.filter(zichtbaar);
    }

    function huidig() {
      var p = open(platen);
      for (var i = 0; i < p.length; i++) {
        if (p[i].classList.contains('aan')) return i;
      }
      return 0;
    }

    function pijlenBij() {
      var p = open(platen);
      var i = huidig();
      pijlen.forEach(function (k) {
        k.style.display = p.length < 2 ? 'none' : '';
        k.disabled = +k.getAttribute('data-plaat-schuif') < 0 ? i === 0 : i >= p.length - 1;
      });
    }

    function duimInBeeld(el) {
      if (!strip || !el) return;
      var vak = strip.getBoundingClientRect();
      var d = el.getBoundingClientRect();
      if (d.left < vak.left) {
        strip.scrollLeft -= vak.left - d.left + 12;
      } else if (d.right > vak.right) {
        strip.scrollLeft += d.right - vak.right + 12;
      }
      if (strip.scrollHeight > strip.clientHeight + 1) {
        if (d.top < vak.top) {
          strip.scrollTop -= vak.top - d.top + 8;
        } else if (d.bottom > vak.bottom) {
          strip.scrollTop += d.bottom - vak.bottom + 8;
        }
      }
    }

    // De markering wordt eerst overal weggehaald en niet alleen bij de zichtbare
    // foto's. Anders blijft hij achter op een foto die net verborgen is, en dan
    // toont de galerij na het wisselen van uitvoering nog de oude foto.
    function toon(i, zacht) {
      var p = open(platen);
      var d = open(duimen);
      if (!p.length) return;
      var n = Math.min(Math.max(i, 0), p.length - 1);
      platen.concat(duimen).forEach(function (el) {
        el.classList.remove('aan');
      });
      laadPlaat(p[n]);
      if(klein.matches && p[n+1])laadPlaat(p[n+1]);
      p[n].classList.add('aan');
      if (d[n]) d[n].classList.add('aan');
      pijlenBij();
      duimInBeeld(d[n]);
      puntjes();
      naarPlaat(p[n], zacht);
    }

    var meetStrip = function () {};

    function applyFilter() {
      var alles = platen.concat(duimen);
      var nu = canoniek(currentSelectedValue(root));

      if (!nu) {
        alles.forEach(function (el) {
          el.classList.remove('uit');
        });
      } else {
        alles.forEach(function (el) {
          var sleutel = el.getAttribute('data-uitvoering') || '';
          el.classList.toggle('uit', sleutel !== '' && sleutel !== nu);
        });
        if (!open(platen).length) {
          alles.forEach(function (el) {
            el.classList.remove('uit');
          });
        }
      }

      if (strip) { strip.scrollLeft = 0; strip.scrollTop = 0; }
      toon(0);
      meetStrip();
    }

    duimen.forEach(function (d) {
      d.addEventListener('click', function () {
        toon(open(duimen).indexOf(d));
      });
    });

    pijlen.forEach(function (k) {
      k.addEventListener('click', function () {
        toon(huidig() + +k.getAttribute('data-plaat-schuif'), true);
      });
    });

    // Drag-to-scroll the thumbnail row. Pointer capture is only taken once a
    // real drag is detected (past a small movement threshold), not on every
    // press - grabbing it immediately would steal the click from whichever
    // thumbnail the pointer happened to land on, and a plain click always has
    // a few pixels of jitter between press and release.
    if (strip) {
      meetStrip = function () {
        strip.classList.toggle('sleepbaar', strip.scrollWidth > strip.clientWidth + 1 || strip.scrollHeight > strip.clientHeight + 1);
        var tot = strip.scrollHeight - strip.clientHeight;
        var kan = tot > 1;
        strip.classList.toggle('scrolt-v', kan && strip.scrollTop < tot - 2);
        strip.classList.toggle('scrolt-op', kan && strip.scrollTop > 2);
        if (knopNeer) knopNeer.hidden = !(kan && strip.scrollTop < tot - 2);
        if (knopOp) knopOp.hidden = !(kan && strip.scrollTop > 2);
      };
      // Pijlknoppen over de verticale miniaturenrij (alleen zichtbaar vanaf 990 px, zie CSS)
      var maakKnop = function (richting, teken) {
        var k = document.createElement('button');
        k.type = 'button';
        k.className = 'kopero-gallery__duimpijl kopero-gallery__duimpijl--' + richting;
        k.hidden = true;
        k.setAttribute('aria-hidden', 'true');
        k.tabIndex = -1;
        k.innerHTML = '<span aria-hidden="true">' + teken + '</span>';
        k.addEventListener('click', function () {
          strip.scrollBy({ top: (richting === 'neer' ? 1 : -1) * strip.clientHeight * 0.75, behavior: 'smooth' });
        });
        gallery.appendChild(k);
        return k;
      };
      var knopNeer = maakKnop('neer', '&darr;');
      var knopOp = maakKnop('op', '&uarr;');
      strip.addEventListener('scroll', meetStrip, { passive: true });
      meetStrip();
      window.addEventListener('resize', meetStrip);

      var neer = false;
      var startX = 0;
      var startL = 0;
      var startY = 0;
      var startT = 0;
      var weg = 0;
      var sleept = false;

      strip.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        neer = true;
        weg = 0;
        sleept = false;
        startX = e.clientX;
        startL = strip.scrollLeft;
        startY = e.clientY;
        startT = strip.scrollTop;
      });

      strip.addEventListener('pointermove', function (e) {
        if (!neer) return;
        var vert = strip.scrollHeight > strip.clientHeight + 1 && window.getComputedStyle(strip).flexDirection === 'column';
        var d = vert ? e.clientY - startY : e.clientX - startX;
        if (Math.abs(d) > weg) weg = Math.abs(d);
        if (weg <= 4) return;
        if (!sleept) {
          sleept = true;
          strip.classList.add('sleept');
          strip.setPointerCapture(e.pointerId);
        }
        if (vert) { strip.scrollTop = startT - d; } else { strip.scrollLeft = startL - d; }
      });

      function los(e) {
        if (!neer) return;
        neer = false;
        if (sleept) {
          strip.classList.remove('sleept');
          if (strip.hasPointerCapture(e.pointerId)) strip.releasePointerCapture(e.pointerId);
        }
        sleept = false;
      }

      strip.addEventListener('pointerup', los);
      strip.addEventListener('pointercancel', los);

      strip.addEventListener(
        'click',
        function (e) {
          if (weg > 4) {
            e.preventDefault();
            e.stopPropagation();
          }
          weg = 0;
        },
        true
      );

      strip.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }

    plaatsPijlen();
    pijlenBij();
    puntjes();

    if (hoofd) {
      var wacht = 0;
      hoofd.addEventListener('scroll', function () {
        if (!klein.matches) return;
        clearTimeout(wacht);
        wacht = setTimeout(function () {
          var p = open(platen);
          if (!p.length) return;
          var x = hoofd.scrollLeft;
          var best = 0;
          var afstand = 1e9;
          p.forEach(function (el, k) {
            var a = Math.abs(el.offsetLeft - x);
            if (a < afstand) { afstand = a; best = k; }
          });
          if (x >= hoofd.scrollWidth - hoofd.clientWidth - 2) best = p.length - 1;
          if (best !== huidig()) {
            var d = open(duimen);
            platen.concat(duimen).forEach(function (el) { el.classList.remove('aan'); });
            p[best].classList.add('aan');
            if (d[best]) d[best].classList.add('aan');
            puntjes();
            pijlenBij();
          }
        }, 50);
      }, { passive: true });
      if (klein.addEventListener) klein.addEventListener('change', function () { plaatsPijlen(); puntjes(); toon(huidig()); });
    }

    root.addEventListener('change', function (event) {
      if (event.target && event.target.closest('variant-selects')) {
        setTimeout(applyFilter, 0);
      }
    });

    if (window.subscribe && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(applyFilter, 50);
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('product-info').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
